import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IInbox, Inbox } from "@/models/inbox.entity";
import inboxService from "@/services/mrfiktiv/services/inboxService";
import { MrfiktivInboxControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Module, getModule } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { InboxDataAccessLayer } from "./access-layers/inbox.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";

const InboxPageDataProvider = new (class extends AbstractPageDataProvider<IInbox, MrfiktivInboxControllerGetParamsGen> {
  itemsPerPage = 100;

  async getPage(query: MrfiktivInboxControllerGetParamsGen): Promise<IPageViewModel<IInbox>> {
    const res = await inboxService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IInbox[];

    return { meta, data };
  }
})();

@Module({
  dynamic: true,
  namespaced: true,
  name: "inbox",
  store
})
export class InboxPaginatedStore extends PaginatedBaseStore<IInbox, MrfiktivInboxControllerGetParamsGen> {
  protected _data = InboxDataAccessLayer;
  protected _pageProvider = InboxPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = Inbox.filterables;
}

export const InboxEntityModule = getModule(InboxPaginatedStore);
